import { FC, useEffect, useState } from "react";
import "./create.css"; // CSS que contém a moldura (createPage e createContent)

import { useLocation, useNavigate } from "react-router-dom";
import { Outlet, Route, Routes } from "react-router-dom";
import { CreateAccount } from "./create/create";
import { ValidateAccount } from "./validate/validate";
import { SuccessPage } from "./success/success";
import { Footer } from "../../components/Footer/footer";

const AccountLayout: FC<any> = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [show, setShow] = useState(true);

  function shouldShow() {
    const currentPath = location.pathname;
    const pathEnd = currentPath.substring(currentPath.lastIndexOf("/") + 1);

    if (pathEnd === "success") {
      setShow(false);
    } else {
      setShow(true);
    }
  }

  useEffect(() => {
    shouldShow();
  }, [location.pathname]);

  return (
    <div className="createPage">
      {/* O createContent funciona como o cartão flutuante de 28em no Desktop */}
      <div className="createContent">
        {/* O Outlet renderiza os filhos (Create, Validate, Success) */}
        <Outlet />

        {/* {show && <Footer />} */}
      </div>
    </div>
  );
};

const AccountPage = () => {
  return (
    <Routes>
      <Route element={<AccountLayout />}>
        <Route path="" element={<CreateAccount />} />
        <Route path="/validation" element={<ValidateAccount />} />
        <Route path="/success" element={<SuccessPage />} />
      </Route>
    </Routes>
  );
};

export { AccountPage };
